import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { X, ChevronLeft, ChevronRight } from "lucide-react";
import AuthImage from "@/components/AuthImage";

const NavBtn = ({ pos, onClick, testid, title, children }) => (
  <button data-testid={testid} title={title} onClick={(e) => { e.stopPropagation(); onClick(); }}
    className={`absolute ${pos} top-1/2 -translate-y-1/2 rounded-full bg-white/10 hover:bg-white/25 transition-colors p-2.5 sm:p-3 text-white`}>
    {children}
  </button>
);

// Full-screen image viewer. Click backdrop / X / Esc to close; arrows (buttons or keys) switch photos.
export default function Lightbox({ fileId, localUrl, caption, onClose, onPrev, onNext, counter }) {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
      else if (e.key === "ArrowLeft" && onPrev) onPrev();
      else if (e.key === "ArrowRight" && onNext) onNext();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [onClose, onPrev, onNext]);

  if (!fileId) return null;

  return createPortal(
    <div
      data-testid="lightbox"
      onClick={onClose}
      className="fixed inset-0 z-[9999] bg-black/90 flex flex-col items-center justify-center p-4 animate-in fade-in duration-150"
    >
      <button
        data-testid="lightbox-close"
        onClick={onClose}
        className="absolute top-4 right-4 rounded-full bg-white/10 hover:bg-white/20 transition-colors p-2 text-white"
        title="Schließen"
      >
        <X className="h-5 w-5" />
      </button>
      {onPrev && <NavBtn pos="left-2 sm:left-4" onClick={onPrev} testid="lightbox-prev" title="Vorheriges Foto (←)"><ChevronLeft className="h-6 w-6" /></NavBtn>}
      {onNext && <NavBtn pos="right-2 sm:right-4" onClick={onNext} testid="lightbox-next" title="Nächstes Foto (→)"><ChevronRight className="h-6 w-6" /></NavBtn>}
      <AuthImage
        key={fileId}
        fileId={fileId}
        localUrl={localUrl}
        data-testid="lightbox-image"
        onClick={(e) => e.stopPropagation()}
        className="max-w-[85vw] sm:max-w-[88vw] max-h-[85vh] object-contain rounded-lg shadow-2xl"
      />
      {(caption || counter) && (
        <div className="mt-3 text-sm text-white/80 max-w-[90vw] truncate text-center" data-testid="lightbox-caption">
          {counter && <span className="font-mono-tech mr-2" data-testid="lightbox-counter">{counter}</span>}{caption}
        </div>
      )}
    </div>,
    document.body
  );
}
